import { useEffect, useState } from "react";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import {
  addAddiotionDrivertoExclude,
  fetchDataAndMapToField,
  waitForCookie,
  removeDeductFromName,
} from "../../utils/helperFuctions";
import { damageTypeStatus } from "./ReservationPage";

const useReservationLogic = () => {
  const apiRoute = "reservations";
  const onlyForm = undefined;
  const [tabsData, setTabsData] = useState([]);

  const captain = process.env.REACT_APP_CAPTAIN_ID;
  const operatorRole = process.env.REACT_APP_OPERATOR_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;
  const clientRole = process.env.REACT_APP_CLIENT_ROLE;
  const createRoles = [admin, managerRole, financeRole, operatorRole, rentalPartnerRole];

  const currentRole1 = getCookie("_r");
  const isAdmin = currentRole1 === admin;
  const DisabledIfIsCaptain = captain === currentRole1;
  const DisabledIfIsOperator = operatorRole === currentRole1;
  const isReadOnlyRole = currentRole1 === rentalPartnerRole || currentRole1 === clientRole;



  // ... rest of logic
  
  const enabledOnDraftAndOpenAndPickedUpOnly = {
    field: "status.defaultValue",
    isEqual: isAdmin === true ? [] : ["Closed", "Returned", "Canceled"],
  };
  const enabledOnDraftAndOpenOnly = {
    field: "status.defaultValue",
    isEqual:
      isAdmin === true ? [] : ["Picked up", "Closed", "Returned", "Canceled"],
  };

  const enabledOnDraftOnly = {
    field: "status.defaultValue",
    isEqual:
      isAdmin === true
        ? []
        : ["Open", "Picked up", "Closed", "Returned", "Canceled"],
  };
  const enabledOnOpenOnly = {
    field: "status.defaultValue",
    isEqual:
      isAdmin === true
        ? []
        : ["Draft", "Picked up", "Closed", "Returned", "Canceled"],
  };
  const enabledOnPickedUpOnly = {
    field: "status.defaultValue",
    isEqual:
      isAdmin === true
        ? []
        : ["Draft", "Open", "Closed", "Returned", "Canceled"],
  };
  const enabledOnOpenAndPickedUpOnly = {
    field: "status.defaultValue",
    isEqual:
      isAdmin === true ? [] : ["Draft", "Closed", "Returned", "Canceled"],
  };
  const enabledOnOpenPickedUpReturnedOnly = {
    field: "status.defaultValue",
    isEqual: isAdmin === true ? [] : ["Draft", "Closed", "Canceled"],
  };
  const enabledOnPickedUpReturnedOnly = {
    field: "status.defaultValue",
    isEqual: isAdmin === true ? [] : ["Draft", "Open", "Closed", "Canceled"],
  };
  const initFields = [
    {
      name: "branch",
      label: "Branch",
      type: "dropdown",
      isRequired: true,
      disabledIfField: enabledOnDraftOnly,
      err: "Branch is required",
      filters: {
        userRole: `<s>${currentRole1}`,
      },
      lazyloadParam: "Name",
      lazyloadUrl: "branches",
      returnID: true,
      span: 3,
    },
    {
      name: "manager",
      label: "Reservation manager",
      type: "dropdown",
      isRequired: true,
      showParameter: "first_name",
      err: "Reservation manager is required",
      returnID: true,
      filters: {
        branch: "branch.id",
      },
      disabledIfField: enabledOnDraftAndOpenOnly,
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "first_name",
      lazyloadParam2: "last_name",
      concat: true,
      concatBy: " ",
      lazyloadUrl: "users/reservationmanagers",
      span: 3,
    },
    {
      name: "captain",
      label: "Pickup captain",
      type: "dropdown",
      isRequired: true,
      disabledIfField: enabledOnDraftAndOpenOnly,
      showParameter: "first_name",
      err: "Pickup captain is required",
      returnID: true,
      filters: {
        branch: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "first_name",
      lazyloadParam2: "last_name",
      concat: true,
      concatBy: " ",
      lazyloadUrl: "users/reservationcaptains",
      span: 3,
    },
    {
      name: "return_captain",
      label: "Return captain",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      isRequired: true,
      showParameter: "first_name",
      err: "Return captain is required",
      returnID: true,
      filters: {
        branch: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "first_name",
      lazyloadUrl: "users/reservationcaptains",
      lazyloadParam2: "last_name",
      concat: true,
      concatBy: " ",
      span: 3,
    },
    {
      name: "status",
      label: "Change status",
      type: "dropdown",
      disableXButton: true,
      isRequired: true,
      err: "Status is required",
      filters: {
        status: "status.defaultValue",
        changed: "status.changed",
        userRole: `<s>${currentRole1}`,
      },
      refetchOnSave: true,
      defaultOnNew: "Draft",
      // lazyloadFieldChange: ["status"],
      lazyloadParam: "name",
      lazyloadUrl: "reservations/statuses",
      span: 3,
    },
    {
      name: "pickup_fleet_location",
      label: "Pickup location",
      type: "dropdown",
      isRequired: true,
      err: "Pickup location is required",
      disabledIfField: enabledOnDraftAndOpenOnly,
      filters: {
        branch: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      returnID: true,
      span: 3,
      lazyloadUrl: "fleetlocations",
    },
    {
      name: "bill_to_company",
      label: "Bill to company",
      type: "toggle",
      isRequired: false,
      defaultValue: true,
      disabled: true,
      span: 3,
    },
    {
      // billing_cycle is NOT listed in any tab's fields array.
      // It is surfaced in the PageTitle header (next to the Bill button)
      // and its value is tracked here so it gets sent on save.
      name: "billing_cycle",
      label: "Billing cycle",
      type: "toggle",
      isRequired: false,
      defaultOnNew: false,
      disabledIfField: enabledOnPickedUpOnly, // only editable when status is "Picked up"
      span: 3,
    },
    {
      name: "COF_number",
      label: "COF number",
      type: "text",
      isRequired: false,
      placeholder: "e.g. COF-12345",
      span: 3,
    },
    {
      name: "is_custom_pickup",
      label: "Custom address",
      disabledIfField: enabledOnDraftAndOpenOnly,
      type: "toggle",
      isRequired: false,
      span: 3,
      disableCondition: [
        {
          value: true,
          params: ["pickup_fleet_location"],
          showparams: [
            "custom_pickup_city",
            "custom_pickup_state",
            "custom_pickup_street",
          ],
        },
        {
          value: false,
          params: [
            "custom_pickup_city",
            "custom_pickup_state",
            "custom_pickup_street",
          ],
          showparams: ["pickup_fleet_location"],
        },
      ],
      err: "Custom address is required",
    },
    {
      name: "is_custom_return",
      label: "Custom address",
      type: "toggle",
      isRequired: false,
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      span: 3,
      disableCondition: [
        {
          value: true,
          params: ["return_fleet_location"],
          showparams: [
            "custom_return_city",
            "custom_return_state",
            "custom_return_street",
          ],
        },
        {
          value: false,
          params: [
            "custom_return_city",
            "custom_return_state",
            "custom_return_street",
          ],
          showparams: ["return_fleet_location"],
        },
      ],
      err: "Custom address is required",
    },
    {
      name: "custom_pickup_city",
      label: "Custom pickup city / airport name",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenOnly,
      filters: {
        branch: "branch.id",
        state: "custom_pickup_state.defaultValue",
      },
      returnDataAsIs: true,
      lazyloadFieldChange: ["branch", "custom_pickup_state"],
      lazyloadParam: "name",
      lazyloadUrl: "reservations/cities",
      isRequired: false,
      err: "Custom pickup city is required",
      span: 3,
      disabled: true,
    },
    // {
    //   name: "custom_pickup_city",
    //   label: "Custom pickup city",
    //   type: "text",
    //   isRequired: false,

    //   err: "Custom pickup City is required",
    //   span: 3,
    //   disabled: true,
    // },
    {
      name: "custom_pickup_state",
      label: "Custom pickup state / airport",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenOnly,
      filters: {
        branch: "branch.id",
      },
      returnDataAsIs: true,
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "name",
      lazyloadUrl: "reservations/states",
      isRequired: false,
      err: "Custom pickup state is required",
      span: 3,
      disabled: true,
    },
    {
      name: "custom_pickup_street",
      label: "Custom pickup street",
      type: "text",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      err: "Custom pickup street is required",
      span: 3,
      disabled: true,
    },
    {
      name: "pickup_note",
      label: "Pickup note",
      type: "text",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      err: " pickup note is required",
      span: 4,
    },
    {
      name: "pickup_note_2",
      label: "Captain's pickup note",
      type: "text",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      err: " pickup note is required",
      span: 4,
    },
    {
      name: "return_note_2",
      label: "Captain's return note",
      type: "text",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      isRequired: false,
      err: " return note is required",
      span: 4,
    },
    {
      name: "return_note",
      label: "Return note",
      type: "text",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      isRequired: false,
      err: " return note is required",
      span: 4,
    },
    {
      name: "custom_return_city",
      label: "Custom return city / airport name",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      filters: {
        branch: "branch.id",
        state: "custom_return_state.defaultValue",
      },
      lazyloadFieldChange: ["branch", "custom_return_state"],
      lazyloadParam: "name",
      lazyloadUrl: "reservations/cities",
      isRequired: false,
      returnDataAsIs: true,
      err: "Custom return city is required",
      span: 3,
      disabled: true,
    },
    {
      name: "custom_return_state",
      label: "Custom return state / airport",
      type: "dropdown",
      returnDataAsIs: true,
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      filters: {
        branch: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "name",
      lazyloadUrl: "reservations/states",
      stopRefetchingOnChange: true,
      isRequired: false,
      err: "Custom return state is required",
      span: 3,
      disabled: true,
    },
    {
      name: "custom_return_street",
      label: "Custom return street",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      type: "text",
      isRequired: false,
      err: "Custom return street is required",
      span: 3,
      disabled: true,
    },
    {
      name: "pickup_date",
      label: "Pickup date",
      type: "datepicker",
      isRequired: true,
      disabledIfField: enabledOnDraftAndOpenOnly,
      err: "Pickup date is required",
      relatedWith: "return_date",
      isItPickup: true,
      countryCode: "branch.code",
      isClearable: true,
      span: 3,
      allowTime: true,
    },
    {
      name: "return_fleet_location",
      label: "Return location",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      isRequired: true,
      filters: {
        branch: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      lazyloadUrl: "fleetlocations",
      err: "Return location is required",
      returnID: true,
      span: 3,
    },
    {
      name: "custom_return",
      label: "Custom return location",
      type: "text",
      isRequired: false,
      err: "Custom return location is required",
      span: 3,
    },
    {
      name: "return_date",
      // useMaxDateTheDefaultValueIf: {
      //   field: "early_return",
      //   isEqual: true,
      // },
      label: "Return date",
      type: "datepicker",
      minValueFrom: "pickup_date",
      isRequired: true,
      disabledIfField: enabledOnDraftAndOpenOnly,
      err: "Return date is required",
      countryCode: "branch.code",
      isItPickup: true,
      minDate: "pickup_date",
      isClearable: true,
      allowTime: true,
      span: 3,
    },
    {
      name: "contact",
      label: "Customer",
      type: "dropdown",
      isRequired: true,
      err: "Customer is required",
      disabledIfField: enabledOnDraftAndOpenOnly,
      // addNew: {
      //   apiUrlRoute: "contacts",
      //   formOptions: {
      //     label: "Add new customer",
      //     fields: [
      //       {
      //         name: "first_name",
      //         label: "First name",
      //         type: "text",
      //         isRequired: true,
      //         err: "First name is required",
      //         span: 3,
      //       },
      //       {
      //         name: "last_name",
      //         label: "Last name",
      //         type: "text",
      //         isRequired: true,
      //         err: "Last name is required",
      //         span: 3,
      //       },
      //       {
      //         name: "phone_number",
      //         label: "Phone Number",
      //         type: "phone",
      //         isRequired: true,
      //         err: "Phone Number is required",
      //         span: 3,
      //       },
      //       {
      //         name: "email",
      //         label: "Email",
      //         type: "email",
      //         err: "Email is required",
      //         isRequired: true,
      //         validation: {
      //           url: "contacts/contactExists",
      //           body: {
      //             email: "email",
      //           },
      //           confirmation: {
      //             exists: false,
      //           },
      //         },
      //         span: 3,
      //       },
      //       {
      //         name: "date_of_birth",
      //         label: "Date of birth",
      //         type: "datepicker",
      //         isRequired: false,
      //         err: "Date of birth is required",
      //         span: 3,
      //       },
      //       {
      //         name: "nationality",
      //         label: "Nationality",
      //         type: "dropdown",
      //         isRequired: false,
      //         err: "Nationality is required",
      //         data: countries,
      //         span: 3,
      //       },
      //       {
      //         name: "country",
      //         label: "Country",
      //         type: "dropdown",
      //         isRequired: false,
      //         err: "Country is required",
      //         data: countries,
      //         span: 3,
      //       },
      //       {
      //         name: "city",
      //         label: "City",
      //         type: "text",
      //         isRequired: false,
      //         err: "City is required",
      //         span: 3,
      //       },
      //       {
      //         name: "state",
      //         label: "State",
      //         type: "text",
      //         isRequired: false,
      //         err: "State is required",
      //         span: 3,
      //       },
      //       {
      //         name: "street1",
      //         label: "Street",
      //         type: "text",
      //         isRequired: false,
      //         err: "Street is required",
      //         span: 3,
      //       },
      //       {
      //         name: "company",
      //         label: "Company",
      //         type: "dropdown",
      //         isRequired: false,
      //         err: "Company is required",
      //         returnID: true,
      //         span: 3,
      //         lazyloadUrl: "companies",
      //       },
      //       {
      //         name: "id_number",
      //         label: "Identification number",
      //         type: "text",
      //         isRequired: false,
      //         err: "Identification number is required",
      //         span: 3,
      //       },
      //       {
      //         name: "id_number_expiry",
      //         label: "Identification expiry",
      //         type: "datepicker",
      //         isRequired: false,
      //         err: "Id number's expiry is required",
      //         span: 3,
      //       },

      //       {
      //         name: "driver_license_number",
      //         label: "Driver's license number",
      //         type: "text",
      //         isRequired: false,
      //         err: "Driver's license number is required",
      //         span: 3,
      //       },
      //       {
      //         name: "driver_license_expiry",
      //         label: "Driver's license expiry",
      //         type: "datepicker",
      //         isRequired: false,
      //         err: "Driver's license expiry is required",
      //         span: 3,
      //       },
      //       {
      //         name: "driver_license",
      //         label: "Front: Driver's license",
      //         type: "file",
      //         isRequired: false,
      //         err: "Front: Driver's license file is required",
      //         isMulti: false,
      //         span: 3,
      //       },
      //       {
      //         name: "driver_license_back",
      //         label: "Back: Driver's license",
      //         type: "file",
      //         isRequired: false,
      //         err: "Back: Driver's license file is required",
      //         isMulti: false,
      //         span: 3,
      //       },
      //       {
      //         name: "id_document",
      //         label: "Front: Identification",
      //         type: "file",
      //         isRequired: false,
      //         err: "Front: Identification document is required",
      //         isMulti: false,
      //         span: 3,
      //       },
      //       {
      //         name: "id_document_back",
      //         label: "Back: Identification",
      //         type: "file",
      //         isRequired: false,
      //         err: "Back: Identification document is required",
      //         isMulti: false,
      //         span: 3,
      //       },
      //     ],
      //   },
      // },
      returnID: true,
      span: 3,
    },
    {
      name: "vehicle_class",
      label: "Vehicle category",
      type: "dropdown",
      isRequired: false,
      err: "Vehicle category is required",
      defaultsTo: "vehicle.class.id",
      placeholder: "Defaults to vehicle's category",
      returnID: true,
      disabled: true,
      displayTextOnly: true,
      span: 3,
    },
    // {
    //   name: "vehicle_category_display",
    //   label: "Desired vehicle",
    //   type: "textDisplay",
    //   displayValue: "vehicle_category_display.name",
    //   displayValue2: "vehicle_category_display.name",
    //   span: 3,
    // },
    {
      name: "vehicle_category_display",
      label: "Desired Vehicle",
      placeholder: "Choose a vehicle",
      type: "popupSelection",
      disabledIfField: enabledOnDraftAndOpenOnly,
      dataParam: "categories",
      isRequired: true,
      err: "Desired vehicle is required",
      url: "public/vehicleCategories",
      removeValueOnWhichFieldValueChange: "branch.defaultValue",
      filters: {
        // status: "<s>Available",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
      },
      dependson: ["pickup_date", "return_date", "branch"],
      isSearchable: true,
      searchPlaceholder: "Search by brand, model, year, type",
      returnParameter: "displayId",
      span: 3,
      toShow: {
        imageUrl: "image.name",
        id: "id",
        name: "title",
        displayId: "displayId",
        //status: "status",
        // title: "plate",
        subTitle: "className",
        classId: "class.id",
      },
      statusColors: {
        Available: "text-green-700 ring-green-600/20 bg-green-50",
        Unavailable: "text-red-700 ring-red-600/20 bg-red-50",
        Maintenance: "text-blue-700 ring-blue-600/20 bg-blue-50",
      },
    },
    {
      name: "mileage_option",
      label: "Mileage option",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: true,
      err: "Mileage option is required",
      returnID: true,
      filters: {
        location: "branch.id",
        class: "vehicle_category_display.class.id",
      },
      lazyloadFieldChange: ["branch", "vehicle_category_display"],
      lazyloadParam: "mileage_option",
      lazyloadParamName: "name",
      lazyloadUrl: "mileageoptionsrates",
      span: 3,
    },
    {
      name: "kilometers_limit",
      label: "Km limit",
      type: "number",
      minValue: 0,
      isRequired: true,
      disabledIfField: enabledOnDraftAndOpenOnly,
      err: "Km limit is required",
      lazyloadUrl: "reservations/kilometerlimit",
      lazyloadParam: "amount",
      lazyloadFieldChange: ["pickup_date", "return_date", "mileage_option"],
      body: {
        fromFields: {
          pickup_date: "pickup_date",
          return_date: "return_date",
          mileage_option: "mileage_option.id",
          grace_period: "grace_period",
        },
      },
      span: 3,
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: true,
      err: "Currency is required",
      placeholder: "Will take branch currency",
      returnID: true,
      disabled: true,
      defaultsTo: "branch.currency.id",
      span: 3,
    },
    {
      name: "coverage_option",
      label: "Coverage option",
      type: "dropdown",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: true,
      err: "Coverage option is required",
      filters: {
        location: "branch.id",
      },
      lazyloadFieldChange: ["branch"],
      lazyloadParam: "coverage_option",
      lazyloadParamName: "name",
      lazyloadUrl: "coverageoptionrates",
      returnID: true,
      span: 3,
    },
    {
      type: "whitespace",
      name: "whitespace",
      span: 3,
    },
    {
      type: "whitespace",
      name: "whitespace2",
      span: 3,
    },
    {
      name: "vehicle",
      label: "Vehicle",
      placeholder: "Choose a vehicle",
      // type: "popupSelection",
      type: "vehiclesDisplay",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      err: "Vehicle is required",
      url: "vehicles",
      removeValueOnWhichFieldValueChange: "branch.defaultValue",
      filters: {
        status: "<s>Available",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
      },
      dependson: ["pickup_date", "return_date", "branch"],
      isSearchable: true,
      searchPlaceholder: "Search by brand, model, year, type",
      returnParameter: "id",
      span: 6,
      toShow: {
        imageUrl: "image.name",
        id: "id",
        name: "brand.name, ,model.name, ,year",
        //status: "status",
        title: "plate",
        subTitle: "class.name",
        classId: "class.id",
      },
      statusColors: {
        Available: "text-green-700 ring-green-600/20 bg-green-50",
        Unavailable: "text-red-700 ring-red-600/20 bg-red-50",
        Maintenance: "text-blue-700 ring-blue-600/20 bg-blue-50",
      },
    },
    {
      name: "vehicle_extra_items",
      label: "Extras items",
      type: "cardToggles",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      disabled: false,
      url: "reservations/vehicle_extraitems",
      body: {
        checked: "<inputvalue>",
        vehicle_extra_item: "<const>itemId",
        reservation: "<id>",
      },
      err: "Extras are required",
      span: 1,
    },
    {
      name: "vehicle_extra_items_return",
      label: "Extras items",
      type: "cardToggles",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      isRequired: false,
      disabled: false,
      url: "reservations/vehicle_extraitems",
      body: {
        checked: "<inputvalue>",
        vehicle_extra_item: "<const>itemId",
        reservation: "<id>",
      },
      err: "Extras are required",
      span: 1,
    },
    {
      name: "reservation_addons",
      label: "Extras",
      type: "card",
      disabledIfField: enabledOnDraftAndOpenOnly,
      isRequired: false,
      url: "/extrasrates",
      err: "Extras are required",
      rowActionsShowNew: true,
      span: 2,
      removeValueOnWhichFieldValueChange: "branch.defaultValue",
      inputField: {
        name: "quantity",
        type: "number",
        minValue: 1,
        maxValue: "limit",
      },
      headerAction: {
        name: "Add",
        id: "add",
      },
      addBarier: {
        name: "addon.id",
      },
      rowActions: [
        {
          name: "Delete",
          id: "update",
          url: "/vehicledamages",
          data: {
            delete: true,
          },
        },
      ],
      toShow: {
        title: "addon.name",
        id: "id",
        tempid: "tempid",
        status: "",
        createdBy: "",
        createdOn: "",
        inputValue: "quantity",
        limit: "addon.limit",
      },
      formOptions: {
        label: "Add New Extra",
        fields: [
          {
            name: "addon",
            label: "Extra",
            type: "dropdown",
            // if item selected before , doesnt appear again in dropdown
            removeElementIfPreviouslyAdded: true,
            fieldParentName: "reservation_addons",
            // end
            isRequired: true,
            err: "Extra is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "addons/noaddtionaldriver",
            filters: {
              branch: "branch.id",
            },
            lazyloadParam2: "limit",
          },
          {
            name: "quantity",
            label: "Quantity",
            type: "number",
            minValue: 1,
            hide: true,
            maxValue: "addon.limit",
            defaultValue: 1,
            isRequired: false,
            err: "Quantity is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "additional_drivers",
      label: "Additional drivers",
      type: "card",
      disabledIfField: enabledOnDraftAndOpenOnly,
      disableWhenDayEnds: true,
      //limit: 3,
      isRequired: false,
      checkWithFiles: [
        {
          param: "contact",
          apiUrlRoute: "contacts",
        },
      ],
      err: "Additional drivers are required",
      span: 2,
      headerAction: {
        name: "Add",
        id: "add",
      },
      toShow: {
        title: "contact.first_name,,contact.last_name",
        id: "id",
        tempid: "tempid",
        status: "contact.email",
        createdBy: "",
        createdOn: "",
        delete: "delete",
      },
      rowActionsShowNew: true,
      affectList: {
        name: "reservation_addons",
        affectsBy: [
          {
            operation: "listcount",
            paramAffected: "quantity",
            rowAffected: {
              param: "addon",
              subparam: "id",
              lazyload: true,
              lazyloadurl: "general",
              lazyloadParam: "additional_driver_addon.id",
              value: "",
            },
          },
        ],
      },
      exclude: {
        name: "delete",
        value: true,
      },
      // exclude: {
      //   lazyload: {
      //     lazyloadurl: 'general',
      //     lazyloadParam: 'additional_driver_addon.id',
      //   },
      //   param: "id",
      //   value: ""
      // },
      rowActions: [
        {
          name: "Delete",
          id: "update",
          data: {
            delete: true,
          },
        },
        // {
        //   name: "Keep",
        //   id: "update",
        //   data: {
        //     delete: false
        //   }
        // }
      ],
      formOptions: {
        label: "Add new driver",
        fields: [
          {
            name: "contact",
            label: "Existing customer",
            type: "dropdown",
            isRequired: true,
            err: "Existing customer is required",
            returnID: true,
            returnObject: true,
            span: 1,
            concat: true,
            concatBy: " ",
            lazyloadParam: "first_name",
            lazyloadParam2: "last_name",
            lazyloadUrl: "contacts",
          },
          // {
          //   name: "contactCard",
          //   type: "singleRelatedCard",
          //   isRequired: true,
          //   relatedParam2: "contact",
          //   label: "Add new driver",
          //   url: "/contacts",
          //   span: 1,
          //   fields: [
          //     {
          //       name: "first_name",
          //       label: "First name",
          //       type: "text",
          //       isRequired: true,
          //       err: "Name is required",
          //       span: 3,
          //     },
          //     {
          //       name: "last_name",
          //       label: "Last name",
          //       type: "text",
          //       isRequired: true,
          //       err: "Name is required",
          //       span: 3,
          //     },
          //     {
          //       name: "phone_number",
          //       label: "Phone Number",
          //       type: "phone",
          //       isRequired: true,
          //       err: "Phone Number is required",
          //       span: 3,
          //     },
          //     {
          //       name: "email",
          //       label: "Email",
          //       type: "email",
          //       err: "Email is required",
          //       isRequired: true,
          //       span: 3,
          //     },
          //     {
          //       name: "date_of_birth",
          //       label: "Date of birth",
          //       type: "datepicker",
          //       isRequired: false,
          //       err: "Date of birth is required",
          //       span: 3,
          //     },
          //     {
          //       name: "nationality",
          //       label: "Nationality",
          //       type: "dropdown",
          //       isRequired: false,
          //       err: "Nationality is required",
          //       data: countries,
          //       span: 3,
          //     },
          //     {
          //       name: "country",
          //       label: "Country",
          //       type: "dropdown",
          //       isRequired: false,
          //       err: "Country is required",
          //       data: countries,
          //       span: 3,
          //     },
          //     {
          //       name: "city",
          //       label: "City",
          //       type: "text",
          //       isRequired: false,
          //       err: "City is required",
          //       span: 3,
          //     },
          //     {
          //       name: "state",
          //       label: "State",
          //       type: "text",
          //       isRequired: false,
          //       err: "State is required",
          //       span: 3,
          //     },
          //     {
          //       name: "street1",
          //       label: "Street",
          //       type: "text",
          //       isRequired: false,
          //       err: "Street is required",
          //       span: 3,
          //     },
          //     {
          //       name: "company",
          //       label: "Company",
          //       type: "dropdown",
          //       isRequired: false,
          //       err: "Company is required",
          //       returnID: true,
          //       span: 3,
          //       lazyloadUrl: "companies",
          //     },
          //     {
          //       name: "id_number",
          //       label: "Identification number",
          //       type: "text",
          //       isRequired: false,
          //       err: "Identification number is required",
          //       span: 3,
          //     },
          //     {
          //       name: "id_number_expiry",
          //       label: "Identification expiry",
          //       type: "datepicker",
          //       isRequired: false,
          //       err: "Identification expiry is required",
          //       span: 3,
          //     },

          //     {
          //       name: "driver_license_number",
          //       label: "Driver's license number",
          //       type: "text",
          //       isRequired: false,
          //       err: "Driver's license number is required",
          //       span: 3,
          //     },
          //     {
          //       name: "driver_license_expiry",
          //       label: "Driver's license expiry",
          //       type: "datepicker",
          //       isRequired: false,
          //       err: "Driver's license expiry is required",
          //       span: 3,
          //     },
          //     {
          //       name: "driver_license",
          //       label: "Front: Driver's license",
          //       type: "file",
          //       isRequired: false,
          //       err: "Front: Driver's license file is required",
          //       isMulti: false,
          //       span: 3,
          //     },
          //     {
          //       name: "driver_license_back",
          //       label: "Back: Driver's license",
          //       type: "file",
          //       isRequired: false,
          //       err: "Back: Driver's license file is required",
          //       isMulti: false,
          //       span: 3,
          //     },
          //     {
          //       name: "id_document",
          //       label: "Front: Identification",
          //       type: "file",
          //       isRequired: false,
          //       err: "Front: Identification document is required",
          //       isMulti: false,
          //       span: 3,
          //     },
          //     {
          //       name: "id_document_back",
          //       label: "Back: Identification",
          //       type: "file",
          //       isRequired: false,
          //       err: "Back: Identification document is required",
          //       isMulti: false,
          //       span: 3,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      name: "pricingHeading",
      type: "simpleHeading",
      label: "Rental pricing",
      span: 1,
    },
    {
      name: "auto_calculate",
      type: "toggle",
      label: "Use system pricing",
      alwaysEnabledIf: [
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      popupOnToggle: {
        title: "Warning",
        TurnOnBody:
          "Are you sure that you want to use system pricing? All prices will be reverted to system prices.",
        TurnOffBody:
          "Are you sure that you want to use custom pricing? Prices will not get calculated automatically.",
      },
      // Removed disabledIfField - now only locked by billing events
      singleLine: true,
      span: 1,
      customFontWeight: 600,
      padding: true,
    },
    {
      name: "rental_price",
      type: "textTwoLabelWithCalc",
      quantityField: "rental_price_per_day",
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      // disabled: DisabledIfIsCaptainOrManager,
      inputType: "number",
      minValue: 0,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      label: "Rental price",
      label2: "currency.name",
      label2Param: true,
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/rentprice",
      lazyloadParam: "amount",
      lazyloadFieldChange: [
        "vehicle_category_display",
        "pickup_date",
        "return_date",
        "branch",
      ],
      body: {
        vehicle: "vehicle_category_display.class",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
        grace_period: "grace_period",
      },
      decimalCount: 2,
      span: 1,
    },
    // {
    //   name: "rental_price",
    //   type: "textTwoLabel",
    //   disabledIfField: enabledOnDraftAndOpenOnly,
    //   disabledIfField2: {
    //     field: "auto_calculate.defaultValue",
    //     isEqual: [true],
    //   },
    //   alwaysEnabledIf: [
    //     { field: "auto_calculate.defaultValue", isEqual: false },
    //     { field: "early_return", isEqual: true },
    //     { field: "status", isEqual: "Picked up" },
    //   ],
    //   // disabled: DisabledIfIsCaptainOrManager,
    //   inputType: "number",
    //   getInitialPriceOnFieldChange: {
    //     field: "auto_calculate",
    //     value: true,
    //   },
    //   label: "Rental price",
    //   label2: "currency.name",
    //   label2Param: true,
    //   initialValueUrl: "reservations/getinitialreservationvalue",
    //   initialValueParam: "amount",
    //   lazyload: "reservations/rentprice",
    //   lazyloadParam: "amount",
    //   lazyloadFieldChange: [
    //     "vehicle_category_display",
    //     "pickup_date",
    //     "return_date",
    //     "branch",
    //   ],
    //   body: {
    //     vehicle: "vehicle_category_display.class",
    //     pickup_date: "pickup_date",
    //     return_date: "return_date",
    //     branch: "branch.id",
    //     grace_period: "grace_period",
    //   },
    //   decimalCount: 2,
    //   span: 1,
    // },
    {
      name: "mileage_amount",
      // disabled: DisabledIfIsCaptainOrManager,
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Mileage price",
      minValue: 0,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      label2: "currency.name",
      label2Param: true,
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/mileageprice",
      lazyloadParam: "amount",
      lazyloadFieldChange: ["mileage_option", "pickup_date", "return_date"],
      body: {
        mileage_option: "mileage_option.id",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
        class: "vehicle_category_display.class",
        grace_period: "grace_period",
      },
      span: 1,
    },
    {
      name: "coverage_amount",
      // disabled: DisabledIfIsCaptainOrManager,
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Coverage price",
      minValue: 0,
      label2: "currency.name",
      label2Param: true,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/coverageprice",
      lazyloadParam: "amount",
      lazyloadFieldChange: [
        "coverage_option",
        "pickup_date",
        "return_date",
        "vehicle_category_display",
      ],
      body: {
        coverage_option: "coverage_option.id",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
        class: "vehicle_category_display.class",
        grace_period: "grace_period",
      },
      span: 1,
    },
    {
      name: "security_deposit",
      // disabled: DisabledIfIsCaptainOrManager,
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      minValue: 0,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Security deposit",
      label2: "currency.name",
      label2Param: true,
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/branchSecurityDeposit",
      lazyloadParam: "security_deposit_amount",
      lazyloadFieldChange: "branch",
      body: {
        branch: "branch.id",
      },
      span: 1,
    },
    {
      name: "extra_price_km",
      type: "textTwoLabel",
      inputType: "number",
      // disabled: DisabledIfIsCaptainOrManager,
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      decimalCount: 2,
      label: "Price of extra kilometer",
      minValue: 0,
      label2: "currency.name",
      label2Param: true,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/chargeperkilometer",
      lazyloadParam: "amount",
      lazyloadFieldChange: ["vehicle_category_display", "mileage_option"],
      body: {
        vehicle_class: "vehicle_category_display.class",
        mileage_option: "mileage_option.id",
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
        grace_period: "grace_period",
      },
      span: 1,
    },
    {
      name: "extra_kms_charge",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 3,
      label: "Extra kilometers charge",
      label2: "currency.name",
      label2Param: true,
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/extraKilometersCharge",
      lazyloadParam: "amount",
      lazyloadFieldChange: [
        "extra_price_km",
        "initial_odometer",
        "return_odometer",
        "kilometers_limit",
      ],
      body: {
        extra_price_km: "extra_price_km",
        initial_odometer: "initial_odometer",
        return_odometer: "return_odometer",
        kilometers_limit: "kilometers_limit",
      },
      span: 1,
      disabled: true,
      hide: true,
    },
    {
      name: "extra_kms_charge2",
      subname: "extra_kms_charge",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Extra kilometers charge",
      label2: "currency.name",
      label2Param: true,
      lazyload: "reservations/extraKilometersCharge",
      lazyloadParam: "amount",
      lazyloadFieldChange: [
        "extra_price_km",
        "return_odometer",
        "kilometers_limit",
      ],
      body: {
        extra_price_km: "extra_price_km",
        initial_odometer: "initial_odometer",
        return_odometer: "return_odometer",
        kilometers_limit: "kilometers_limit",
      },
      span: 2,
      disabled: true,
    },
    {
      name: "extra_price_day",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Extra charge per day",
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "cash_surcharge",
      type: "text",
      inputType: "number",
      decimalCount: 2,
      label: "Extra charge per day",
      label2: "currency.name",
      label2Param: true,
      span: 1,
      hide: true,
    },
    {
      name: "grace_period",
      disabledIfField: enabledOnDraftAndOpenOnly,
      type: "number",
      inputType: "number",
      decimalCount: 0,
      label: "Grace period",
      span: 3,
    },
    {
      name: "contact_balance",
      // disabledIfField: enabledOnDraftAndOpenOnly,
      type: "number",
      inputType: "number",
      decimalCount: 0,
      label: "contact balance",
      span: 3,
      hide: true,
    },
    {
      name: "contact_deposit_balance",
      // disabledIfField: enabledOnDraftAndOpenOnly,
      type: "number",
      inputType: "number",
      decimalCount: 0,
      label: "contact balance",
      span: 3,
      hide: true,
    },
    {
      name: "rental_price_per_day",
      // disabledIfField: enabledOnDraftAndOpenOnly,
      type: "number",
      inputType: "number",
      decimalCount: 0,
      label: "contact balance",
      span: 3,
      hide: true,
    },
    {
      name: "additional_charge",
      type: "textTwoLabel",
      disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
      inputType: "number",
      decimalCount: 2,
      label: "Additional charge",
      label2: "currency.name",
      getFromValue: true,
      label2Param: true,
      span: 1,
    },
    {
      name: "discount",
      type: "textTwoLabel",
      inputType: "number",
      // Removed disabledIfField - now only locked by billing events
      alwaysEnabledIf: [
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      decimalCount: 2,
      minValue: 0,
      label: "Discount",
      getFromValue: true,
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },

    {
      name: "delivery_charges",
      type: "textTwoLabel",
      // Removed disabledIfField - now only locked by billing events
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      alwaysEnabledIf: [
        { field: "auto_calculate.defaultValue", isEqual: false },
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      // disabled: DisabledIfIsCaptainOrManager,
      inputType: "number",
      decimalCount: 2,
      minValue: 0,
      label: "Delivery fees",
      label2: "currency.name",
      label2Param: true,
      getInitialPriceOnFieldChange: {
        field: "auto_calculate",
        value: true,
      },
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/deliveryprice",
      lazyloadParam: "amount",
      lazyloadFieldChange: ["custom_pickup_state", "custom_return_state"],
      body: {
        pickup_date: "pickup_date",
        return_date: "return_date",
        branch: "branch.id",
        is_custom_address_pickup: "is_custom_pickup",
        pickup_address: "custom_pickup_state",
        return_address: "custom_return_state",
        is_custom_address_return: "is_custom_return",
        grace_period: "grace_period",
      },
      span: 1,
    },
    {
      name: "vat",
      type: "textTwoLabel",
      inputType: "number",
      label: "VAT",
      minValue: 0,
      disabledIfField: enabledOnDraftAndOpenOnly,
      alwaysEnabledIf: [
        { field: "early_return", isEqual: true },
        { field: "status", isEqual: "Picked up" },
      ],
      disabled: true,
      label2: "%",
      label2Param: false,
      initialValueUrl: "reservations/getinitialreservationvalue",
      initialValueParam: "amount",
      lazyload: "reservations/branchvat",
      lazyloadParam: "vat",
      lazyloadFieldChange: "branch",
      body: {
        branch: "branch.id",
      },
      span: 1,
    },
    {
      name: "setPayments",
      type: "simpleHeading",
      label: "Check payments",
      span: 1,
    },
    {
      name: "setPayments2",
      type: "simpleHeading",
      label: "Check payments",
      span: 1,
    },
    {
      name: "mainInfoHeading",
      type: "simpleHeading",
      showReservationCodeAndStatus: false,
      secondValueNextToCode: "status",
      label: "Main information",
      span: 1,
    },
    {
      name: "finesAndChargesHeading",
      type: "simpleHeading",
      label: "Fines & charges",
      span: 1,
    },
    {
      name: "mainpickupHeading",
      type: "simpleHeading",
      label: "Pickup information",
      span: 1,
    },
    {
      name: "mainreturnHeading",
      type: "simpleHeading",
      label: "Return information",
      span: 1,
    },
    {
      name: "reservationOptionsHeading",
      type: "simpleHeading",
      label: "Reservation options",
      span: 1,
    },
    {
      name: "security_deposit2",
      subname: "security_deposit",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Security deposit",
      label2: "currency.name",
      label2Param: true,
      span: 2,
      disabled: true,
    },
    {
      name: "balance",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Rental balance",
      label2: "currency.name",
      label2Param: true,
      lazyload: "reservations/getReservationBalance",
      lazyloadParam: "balance",
      lazyloadFieldChange: [
        "extra_kms_charge",
        "rental_price",
        "reservation_addons",
        "transactions",
        "mileage_amount",
        "coverage_amount",
      ],
      body: {
        extra_kms_charge: "extra_kms_charge",
        mileage_amount: "mileage_amount",
        coverage_amount: "coverage_amount",
        rental_price: "rental_price",
        reservation_addons: "reservation_addons",
        transactions: "transactions",
        discount: "discount",
        vat: "vat",
        security_deposit: "security_deposit",
      },
      span: 2,
      disabled: true,
    },
    {
      name: "deposit_balance",
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      label: "Deposit balance",
      label2: "currency.name",
      label2Param: true,
      lazyload: "reservations/getReservationBalance",
      lazyloadParam: "deposit_balance",
      lazyloadFieldChange: ["security_deposit", "transactions"],
      body: {
        extra_kms_charge: "extra_kms_charge",
        mileage_amount: "mileage_amount",
        coverage_amount: "coverage_amount",
        rental_price: "rental_price",
        reservation_addons: "reservation_addons",
        transactions: "transactions",
        discount: "discount",
        vat: "vat",
        security_deposit: "security_deposit",
      },
      span: 2,
      disabled: true,
    },
    {
      name: "salik_charges",
      type: "textTwoLabel",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      inputType: "number",
      decimalCount: 2,
      getFromValue: true,
      label: "Salik",
      disabledIfField2: {
        field: "branch.code",
        isEqual: ["LB"],
      },
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "fines_charges",
      type: "textTwoLabel",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      inputType: "number",
      getFromValue: true,
      decimalCount: 2,
      label: "Fines",
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "cleaning_charges",
      type: "textTwoLabel",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      inputType: "number",
      decimalCount: 2,
      getFromValue: true,
      label: "Cleaning",
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "smoking_charges",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      type: "textTwoLabel",
      inputType: "number",
      decimalCount: 2,
      getFromValue: true,
      label: "Smoking",
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "damages_charges",
      type: "textTwoLabel",
      inputType: "number",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      decimalCount: 2,
      label: "Damages",
      getFromValue: true,
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "fuel_charges",
      type: "textTwoLabel",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      inputType: "number",
      decimalCount: 2,
      getFromValue: true,
      label: "Fuel charges",
      label2: "currency.name",
      label2Param: true,
      span: 1,
    },
    {
      name: "initial_odometer",
      label: "Pickup odometer",
      display: { title: "Current odometer: ", value: "vehicle.odometer" },
      type: "number",
      converter: { ratio: "1.609344", decimal: 0, placeholder: "Miles" },
      minValue: 0,
      disabledIfField: enabledOnOpenOnly,
      isRequired: true,
      err: "Pickup odometer is required",
      span: 4,
    },
    {
      name: "return_odometer",
      disabledIfField: enabledOnPickedUpOnly,
      label: "Return odometer",
      converter: { ratio: "1.609344", decimal: 0, placeholder: "Miles" },
      display: { title: "Current odometer: ", value: "vehicle.odometer" },
      type: "number",
      minValue: "0",
      isRequired: true,
      err: "Return odometer is required",
      span: 4,
    },
    {
      name: "checkCarHeading",
      type: "simpleHeading",
      label: "Check car",
      span: 1,
    },
    {
      name: "checkCaptainHeading",
      type: "simpleHeading",
      label: "Check captain",
      span: 1,
    },
    {
      name: "pickup_fuel_level",
      label: "Pickup fuel level",
      disabledIfField: enabledOnOpenOnly,
      type: "number",
      minValue: 0,
      step: 0.5,
      maxValue: 8,
      isRequired: true,
      err: "Pickup fuel level is required",
      span: 3,
    },
    {
      name: "return_fuel_level",
      disabledIfField: enabledOnPickedUpOnly,
      label: "Return fuel level",
      type: "number",
      minValue: 0,
      step: 0.5,
      maxValue: 8,
      isRequired: true,
      err: "Return fuel level is required",
      span: 3,
    },
    {
      name: "contact_driver_license",
      label: "Driver's license file",
      type: "file",
      isRequired: false,
      err: "Driver's license file is required",
      isMulti: false,
      span: 3,
      childRelated: true,
    },
    {
      name: "contact_id_document",
      label: "Driver's ID Document",
      type: "file",
      isRequired: false,
      err: "Driver's ID Document is required",
      isMulti: false,
      span: 3,
      childRelated: true,
    },
    {
      name: "reservation_addons2",
      subname: "reservation_addons",
      label: "Extras pricing",
      type: "card",
      isRequired: false,
      url: "/resrvationaddons",
      err: "Extras are required",
      span: 1,
      className: "mb-8",
      disabledIfField2: {
        field: "auto_calculate.defaultValue",
        isEqual: [true],
      },
      disableWhenDayEnds: true,
      exclude: {
        name: "delete",
        value: true,
      },
      inputField: {
        name: "price",
        type: "number",
        decimalCount: 2,
        disabledIfField: enabledOnDraftAndOpenAndPickedUpOnly,
        getInitialPriceOnFieldChange: {
          field: "auto_calculate",
          value: true,
        },
        // disabled: DisabledIfIsCaptainOrManager,
        lazyloadUrl: "reservations/addonsprice",
        lazyloadParam: "amount",
        changeParam: "price",
        forceReloadIcon: true,
        lazyloadFieldChange: [
          "pickup_date",
          "return_date",
          "reservation_addons",
        ],
        arrayFieldChangeParentCompare: "addonid",
        arrayFieldChangeCond: {
          reservation_addons: {
            searchField: "addon",
            altSearchField: "tempid",
            changeField: "quantity",
          },
        },
        label: "currency.name",
        body: {
          fromData: {
            addon: "addon.id",
            quantity: "quantity",
          },
          fromFields: {
            pickup_date: "pickup_date",
            return_date: "return_date",
            branch: "branch.id",
            grace_period: "grace_period",
          },
        },
      },
      rowActionsShowNew: true,
      toShow: {
        title: "quantity,<s>X,,addon.name",
        id: "id",
        tempid: "tempid",
        status: "",
        createdBy: "",
        createdOn: "",
        inputValue: "price",
        addonid: "addon.id",
        quantity: "quantity",
        delete: "delete",
      },
      formOptions: {
        label: "Add New Extra",
        fields: [
          {
            name: "addon",
            label: "Extra",
            type: "dropdown",
            isRequired: true,
            err: "Extra is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "addons",
            lazyloadParam2: "limit",
          },
          {
            name: "quantity",
            label: "Quantity",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Quantity is required",
            span: 1,
          },
          {
            name: "price",
            label: "Price",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Price is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "reservation_addons3",
      subname: "reservation_addons",
      label: "Check extras",
      type: "card",
      isRequired: false,
      removeItem: ["Additional Driver", "Zero Deposit Charges"],
      err: "Extras are required",
      span: 1,
      inputField: {
        name: "delivered",
        type: "toggle",
        disabledIfField: enabledOnOpenOnly,
        changeParam: "delivered",
        label: "Delivered",
      },
      exclude: {
        name: "delete",
        value: true,
      },
      rowActionsShowNew: true,
      toShow: {
        title: "quantity,<s>X,,addon.name",
        id: "id",
        tempid: "tempid",
        status: "",
        createdBy: "",
        createdOn: "",
        inputValue: "delivered",
        addonid: "addon.id",
        quantity: "quantity",
        delete: "delete",
        delivered: "delivered",
      },
      formOptions: {
        label: "Add New Extra",
        fields: [
          {
            name: "addon",
            label: "Extra",
            type: "dropdown",
            isRequired: true,
            err: "Extra is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "addons",
          },
          {
            name: "quantity",
            label: "Quantity",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Quantity is required",
            span: 1,
          },
          {
            name: "price",
            label: "Price",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Price is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "reservation_addons4",
      subname: "reservation_addons",
      label: "Check extras",
      type: "card",
      isRequired: false,
      removeItem: ["Additional Driver", "Zero Deposit Charges"],
      url: "/resrvationaddons",
      err: "Extras are required",
      span: 1,
      inputField: {
        name: "returned",
        type: "toggle",
        disabledIfField: enabledOnPickedUpOnly,
        changeParam: "returned",
        label: "Returned",
      },
      rowActionsShowNew: true,
      exclude: {
        name: "delete",
        value: true,
      },
      toShow: {
        title: "quantity,<s>X,,addon.name",
        id: "id",
        tempid: "tempid",
        status: "",
        createdBy: "",
        createdOn: "",
        inputValue: "returned",
        addonid: "addon.id",
        quantity: "quantity",
        delete: "delete",
        delivered: "returned",
      },
      formOptions: {
        label: "Add New Extra",
        fields: [
          {
            name: "addon",
            label: "Extra",
            type: "dropdown",
            isRequired: true,
            err: "Extra is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "addons",
          },
          {
            name: "quantity",
            label: "Quantity",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Quantity is required",
            span: 1,
          },
          {
            name: "price",
            label: "Price",
            type: "number",
            minValue: 0,
            isRequired: false,
            err: "Price is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "transactions",
      label: "Transactions",
      disabledIfField: enabledOnOpenPickedUpReturnedOnly,
      disableWhenDayEnds: true,
      type: "card",
      isRequired: false,
      url: "/transactions",
      err: "Transactions are required",
      span: 1,
      affectsOn: {
        name: "balance",
        subname: "amount",
        operation: "subtract",
        condition: "Payment",
        compareWith: "type.name",
      },
      affectsOn2: {
        name: "deposit_balance",
        subname: "amount",
        operation: "add",
        condition: "Deposit",
        compareWith: "type.name",
      },
      inputField: {
        name: "amount",
        type: "number",
        minValue: 0,
        label: "currency.name",
      },
      headerAction: {
        name: "Add",
        id: "add",
        concatWith: {
          currency: "currency.id",
          user_created: "<s>You",
          date_created: "<now>",
        },
      },
      toShow: {
        title: "type.name",
        id: "id",
        tempid: "tempid",
        status: "method.name",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        inputValue: "amount",
        reference: "reference",
      },
      exclude: {
        name: "delete",
        value: true,
      },
      rowActions: [
        {
          name: "Edit",
          id: "edit",
          // url: "/vehicledamages",
        },
        {
          name: "Delete",
          id: "update",
          // url: "/vehicledamages",
          data: {
            delete: true,
          },
        },
        {
          name: "Generate Receipt",
          id: "gen-rec",
          // url: "/vehicledamages",
        },
        {
          name: "Email Receipt ",
          id: "email-rec",
          // url: "/vehicledamages",
        },
      ],
      formOptions: {
        label: "Add New Transaction",
        fields: [
          {
            name: "type",
            label: "Transaction type",
            type: "dropdown",
            isRequired: true,
            err: "Transaction type is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "transactiontypes",
          },
          {
            name: "reference",
            label: "Reference",
            type: "text",
            err: "Amount is required",
            span: 1,
          },
          {
            name: "method",
            label: "Transaction method",
            type: "dropdown",
            isRequired: true,
            err: "Transaction method is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "transactionmethods",
          },
          {
            name: "amount",
            label: "Amount",
            type: "number",
            minValue: 0,
            isRequired: true,
            err: "Amount is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "charges",
      label: "Fines & Charges",
      disabledIfField: enabledOnPickedUpReturnedOnly,
      disableWhenDayEnds: true,
      type: "card",
      isRequired: false,
      url: "/charges",
      err: "Charges are required",
      span: 1,
      affectsOn: {
        name: "balance",
        subname: "amount",
        operation: "subtract",
        condition: "Payment",
        compareWith: "value.name",
      },
      affectsOn2: {
        name: "deposit_balance",
        subname: "amount",
        operation: "add",
        condition: "Deposit",
        compareWith: "value.name",
      },
      inputField: {
        name: "amount",
        type: "number",
        label: "currency.name",
        minValue: 0,
      },
      headerAction: {
        name: "Add",
        id: "add",
        concatWith: {
          currency: "currency.id",
          user_created: "<s>You",
          date_created: "<now>",
        },
      },
      toShow: {
        title: "value.name",
        id: "id",
        tempid: "tempid",
        deduct: "value.deduct",
        taxable: "value.taxable",
        // status: "value.name",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        description: "description",
        inputValue: "amount",
      },
      exclude: {
        name: "delete",
        value: true,
      },
      rowActions: [
        {
          name: "Edit",
          id: "edit",
          // url: "/vehicledamages",
        },
        {
          name: "Delete",
          id: "update",
          // url: "/vehicledamages",
          data: {
            delete: true,
          },
        },
      ],
      formOptions: {
        label: "Add New Transaction",
        fields: [
          {
            name: "charges_deduct_toggle",
            label: "Deduct",
            type: "toggle",
            defaultValue: false,
            span: 1,
          },
          {
            name: "value",
            label: "Charge type",
            type: "dropdown",
            isRequired: true,
            err: "Charge value is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "chargesvalues/filter",
            lazyloadParam2: "deduct",
            lazyloadParam3: "taxable",
            filters: {
              deduct: "charges_deduct_toggle",
            },
            lazyloadFieldChange: ["charges_deduct_toggle"],
            nameTransformer: removeDeductFromName,
          },
          {
            name: "amount",
            label: "Amount",
            type: "number",
            minValue: 0,
            isRequired: true,
            err: "Amount is required",
            span: 1,
          },
          {
            name: "description",
            label: "Description",
            type: "text",
            minValue: 0,
            isRequired: false,
            err: "Amount is required",
            span: 1,
          },
        ],
      },
    },
    {
      name: "time_extension",
      label: "Return date adjustment",
      onlyLatestCanBeDeleted: true,
      disabledIfField: enabledOnPickedUpReturnedOnly,
      disableWhenDayEnds: true,
      type: "card",
      lazyload: "reservations/rentpricewithdays",
      lazyloadParam: "amount",
      calculateTotalAmount: {
        amountField: "days",
        rateField: "rate",
        dateExtended: "date_extended",
        useSystemPrice: "use_system_price",
        lazyloadFormValues: {
          return_date: "return_date",
          vehicle: "vehicle_category_display.class",
          branch: "branch.id",
          rental_price: "rental_price",
        },
      },
      isRequired: false,
      span: 1,
      affectsOn: {
        name: "balance",
        subname: "amount",
        operation: "subtract",
        condition: "Payment",
        compareWith: "value.name",
      },
      affectsOn2: {
        name: "deposit_balance",
        subname: "amount",
        operation: "add",
        condition: "Deposit",
        compareWith: "value.name",
      },
      inputField: {
        name: "total",
        type: "number",
        minValue: 0,
        label: "currency.name",
      },
      headerAction: {
        name: "Add",
        id: "add",
        concatWith: {
          currency: "currency.id",
          user_created: "<s>You",
          date_created: "<now>",
        },
      },
      toShow: {
        title: "date_extended , ,<s>days",
        id: "id",
        tempid: "tempid",
        // status: "value.name",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        rate: "rate",
        days: "days",
        inputValue: "total",
        total: "total",
        dateExtended: "date_extended",
        adjustmentType: "adjustment_type",
        useSystemPrice: "use_system_price",
      },
      exclude: {
        name: "delete",
        value: true,
      },
      rowActions: [
        {
          name: "Delete",
          id: "update",
          // url: "/vehicledamages",
          data: {
            delete: true,
          },
        },
      ],
      formOptions: {
        label: "Add New Transaction",
        fields: [
          {
            name: "date_extended",
            label: "Date",
            type: "datepicker",
            disableInput: true,
            countryCode: "branch.code",
            allowTime: true,
            isRequired: true,
            reduceMinDateDays: 0,
            err: "Date is required",
            minValueFrom: "pickup_date",
            // minValueFromObj: {
            //   field: "time_extension.defaultValue",
            //   subField: "date_extended",
            //   array_item: "last",
            // },
            span: 1,
          },
        ],
      },
    },
    {
      name: "vehicleCard",
      type: "singleRelatedCard",
      relatedParam: "vehicle",
      label: "Check damages",
      url: "/vehicles",
      // filters: {
      //   //status : '<s>Available',
      //   damagestatus: '<s>Pending',
      // },
      span: 1,
      affectsOn: [
        // {
        //   name: "initial_odometer",
        //   subname: "odometer",
        //   operation: "equal",
        // },
        // {
        //   name: "pickup_fuel_level",
        //   subname: "fuel_level",
        //   operation: "equal",
        // },
      ],
      fields: [
        {
          name: "damageImage",
          related: "vehicle_damages",
          disabledIfField: enabledOnOpenOnly,
          label: "Damage image",
          type: "clickableImage",
          isRequired: false,
          url: "/vehicleDamages",
          err: "Damage image is required",
          data: {
            stage: "pickup",
          },
          parentId: true,
          parentParamName: "reservationId",
          exclude: {
            name: "status",
            value: "Fixed",
          },
          span: 2,
          mdSpan: 6,
        },
        {
          name: "vehicle_damages",
          label: "Vehicle damages",
          type: "card",
          scroll: true,
          isRequired: false,
          rowActionsShowNew: true,
          apiUrl: "vehicledamages",
          parentParam: "vehicle",
          span: 2,
          exclude: {
            name: "status",
            value: "Fixed",
          },
          // mainAction: {
          //   name: "View",
          //   id: "view",
          //   url: "/vehicledamage"
          // },
          // rowActions: [
          //   {
          //     name: "Edit",
          //     id: "edit",
          //     url: "/vehicledamages"
          //   },
          //   {
          //     name: "Mark Fixed",
          //     id: "update",
          //     url: "/vehicledamages",
          //     data: {
          //       status: "Fixed"
          //     }
          //   }
          // ],
          toShow: {
            title: "number,<s>-,damage_type.name",
            id: "id",
            status: "status",
            createdBy: "user_created.first_name, ,user_created.last_name",
            createdOn: "date_created",
            image: "image.name",
          },
          formOptions: {
            label: "Create New Damage",
            fields: [
              {
                name: "status",
                label: "Status",
                type: "dropdown",
                isRequired: true,
                err: "Status is required",
                returnID: false,
                span: 1,
                data: damageTypeStatus,
                defaultValue: "Pending",
                hide: true,
              },
              {
                name: "damage_type",
                label: "Damage type",
                type: "dropdown",
                isFieldReadOnly:
                  DisabledIfIsCaptain || DisabledIfIsOperator ? true : false,
                isRequired: true,
                err: "Damage type is required",
                returnID: true,
                returnObject: true,
                span: 1,
                lazyloadUrl: "damagetypes",
              },
              {
                name: "description",
                label: "Description",
                type: "text",
                isRequired: false,
                err: "Description is required",
                span: 1,
              },
              {
                name: "image",
                label: "Damage image",
                type: "file",
                isRequired: false,
                err: "Image is required",
                isMulti: false,
                span: 3,
              },
            ],
          },
        },
      ],
    },
    {
      name: "vehicleCard2",
      type: "singleRelatedCard",
      relatedParam: "vehicle",
      label: "Check damages",
      url: "/vehicles",
      // filters: {
      //   //status : '<s>Available',
      //   damagestatus: '<s>Pending',
      // },
      span: 1,
      affectsOn: [
        // {
        //   name: "return_odometer",
        //   subname: "odometer",
        //   operation: "equal",
        // },
        // {
        //   name: "return_fuel_level",
        //   subname: "fuel_level",
        //   operation: "equal",
        // },
      ],
      fields: [
        // {
        //   name: "odometer",
        //   label: "Odometer",
        //   type: "number",
        //   disabledIfField: enabledOnPickedUpOnly,
        //   minValue: 0,
        //   isRequired: true,
        //   err: "Odometer is required",
        //   span: 3,
        // },
        // {
        //   name: "fuel_level",
        //   label: "Fuel level",
        //   type: "number",
        //   disabledIfField: enabledOnPickedUpOnly,
        //   isRequired: false,
        //   err: "Fuel level is required",
        //   span: 3,
        //   minValue: 0,
        //   maxValue: 8,
        // },
        {
          name: "damageImage",
          related: "vehicle_damages",
          label: "Damage image",
          type: "clickableImage",
          disabledIfField: enabledOnPickedUpOnly,
          isRequired: false,
          url: "/vehicleDamages?status=Pending",
          err: "Damage image is required",
          data: {
            stage: "return",
          },
          parentId: true,
          parentParamName: "reservationId",
          exclude: {
            name: "status",
            value: "Fixed",
          },
          span: 2,
          mdSpan: 6,
        },
        {
          name: "vehicle_damages",
          label: "Vehicle damages",
          type: "card",
          scroll: true,
          isRequired: false,
          rowActionsShowNew: true,
          apiUrl: "vehicledamages",
          parentParam: "vehicle",
          url: "/vehicleDamages",
          err: "Damage image is required",
          span: 2,
          exclude: {
            name: "status",
            value: "Fixed",
          },
          // mainAction: {
          //   name: "View",
          //   id: "view",
          //   url: "/vehicledamage",
          // },
          // rowActions: [
          //   {
          //     name: "Edit",
          //     id: "edit",
          //     url: "/vehicledamages",
          //   },
          //   {
          //     name: "Mark Fixed",
          //     id: "update",
          //     url: "/vehicledamages",
          //     data: {
          //       status: "Fixed",
          //     },
          //   },
          // ],
          toShow: {
            title: "number,<s>-,damage_type.name",
            id: "id",
            status: "status",
            createdBy: "user_created.first_name, ,user_created.last_name",
            createdOn: "date_created",
            image: "image.name",
          },
          formOptions: {
            label: "Create New Damage",
            fields: [
              {
                name: "status",
                label: "Status",
                type: "dropdown",
                isRequired: true,
                err: "Status is required",
                returnID: false,
                span: 1,
                data: damageTypeStatus,
                defaultValue: "Pending",
                hide: true,
              },
              {
                name: "damage_type",
                label: "Damage type",
                type: "dropdown",
                isFieldReadOnly:
                  DisabledIfIsCaptain || DisabledIfIsOperator ? true : false,
                isRequired: true,
                err: "Damage type is required",
                returnID: true,
                returnObject: true,
                span: 1,
                lazyloadUrl: "damagetypes",
              },
              {
                name: "description",
                label: "Description",
                type: "text",
                isRequired: false,
                err: "Description is required",
                span: 1,
              },
              {
                name: "image",
                label: "Damage image",
                type: "file",
                isRequired: false,
                err: "Image is required",
                isMulti: false,
                span: 1,
              },
            ],
          },
        },
      ],
    },
    {
      name: "contactCard",
      type: "singleRelatedCard",
      relatedParam: "contact",
      label: "Check driver's details",
      url: "/contacts",
      span: 1,
      fields: [
        {
          name: "id_number",
          label: "Identification ID/Number*",
          type: "text",
          disabledIfField: enabledOnOpenOnly,
          isRequired: true,
          err: "Identification ID/Number is required",
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "id_number_expiry",
          label: "Id number expiry*",
          validateExpiry: true,
          disabledIfField: enabledOnOpenOnly,
          type: "datepicker",
          isRequired: true,
          isClearable: true,
          err: "Id number expiry is required",
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "id_document",
          label: "Front: Identification document",
          disabledIfField: enabledOnOpenOnly,
          type: "file",
          isRequired: false,
          err: "Identification document is required",
          isMulti: false,
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "id_document_back",
          label: "Back: Identification document",
          disabledIfField: enabledOnOpenOnly,
          type: "file",
          isRequired: true,
          err: "Back: Identification document is required",
          isMulti: false,
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "driver_license_number",
          label: "Driver's license number*",
          disabledIfField: enabledOnOpenOnly,
          type: "text",
          validateExpiry: true,
          isRequired: true,
          err: "Driver's license number is required",
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "driver_license_expiry",
          validateExpiry: true,
          label: "Driver's license expiry*",
          disabledIfField: enabledOnOpenOnly,
          type: "datepicker",
          isRequired: true,
          isClearable: true,
          err: "Driver's license expiry is required",
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },

        {
          name: "driver_license",
          label: "Front: Driver's license file",
          type: "file",
          disabledIfField: enabledOnOpenOnly,
          isRequired: false,
          err: "Driver's license file is required",
          isMulti: false,
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
        {
          name: "driver_license_back",
          label: "Back: Driver's license file",
          disabledIfField: enabledOnOpenOnly,
          type: "file",
          isRequired: false,
          err: "Back: Driver's license file is required",
          isMulti: false,
          span: 2,
          // disabled: DisabledIfIsCaptain,
        },
      ],
    },
    {
      name: "signature",
      type: "esignature",
      label: "Customer's signature",
      disabledIfField: enabledOnOpenOnly,
      trigger: ["pickup_contract", "customer_rta_contract"],
      span: 6,
      // fieldsToValidate: ["initial_odometer", "pickup_fuel_level"],
      buttonText: "Generate customer's documents",
      secondButton: {
        text: "Email contract to customer",
        body: {
          reservationId: "<id>",
          contractType: "<value>pickup_contract",
        },
        url: "/api/reservations/sharecontractbyemail",
      },
    },
    {
      name: "captain_signature",
      type: "esignature",
      disabledIfField: enabledOnOpenOnly,
      label: "Captain's signature",
      hideComponent: [
        {
          if: "is_custom_pickup.defaultValue",
          equalsTo: false,
        },
        {
          if: "branch.code",
          equalsTo: "LB",
        },
      ],
      trigger: ["pickup_captain_contract"],
      span: 6,

      buttonText: "Generate captain's documents",
    },
    {
      name: "return_signature",
      type: "esignature",
      // fieldsToValidate: ["return_odometer", "return_fuel_level"],
      disabledIfField: enabledOnPickedUpOnly,
      label: "Customer's contract",
      trigger: ["return_contract"],
      span: 2,
      buttonText: "Generate contract",
      secondButton: {
        text: "Email contract to customer",
        body: {
          reservationId: "<id>",
          contractType: "<value>return_contract",
        },
        url: "/api/reservations/sharecontractbyemail",
      },
    },
    {
      name: "pickup_contract_id",
      label: "Customer's contract number",
      type: "text",
      isRequired: false,
      err: "Captain's contract number is required",
      span: 2,
      disabled: false,
    },
    {
      name: "rates_change_history",
      type: "text",

      hide: true,
    },
    {
      name: "date_updated",
      type: "text",

      hide: true,
    },
    {
      name: "pickup_captain_contract_id",
      label: "Captain's contract number",
      type: "text",
      isRequired: false,
      hideComponent: [
        {
          if: "is_custom_pickup.defaultValue",
          equalsTo: false,
        },
        {
          field: "branch.code",
          isEqual: "LB",
        },
      ],
      err: "Captain's contract number is required",
      span: 6,
      disabled: false,
    },
    {
      name: "pickup_contract",
      label: "Generated contract",
      type: "fileFetcher",
      filename: "Pickup Contract - Customer",
      url: "reservations/pickupcontract",
      downloadurl: "reservations/downloadpickupcontract",
      extraButton: {
        text: "Finalize pickup",
        param: "status",
        apiUrl: "reservations",
        value: "Picked up",
      },
      listView: {
        displayName: "Pickup Contract - Customer",
      },
      withID: true,
      buttonText: "Generate",
      hideButton: true,
      span: 6,
    },
    {
      name: "customer_rta_contract",
      label: "Generated contract",
      type: "fileFetcher",
      filename: "Pickup Contract - Customer - RTA",
      url: "reservations/pickuprtacontract",
      downloadurl: "reservations/downloadpickuprtacontract",
      hideIfField: {
        field: "branch.code",
        equalsTo: "LB",
      },
      extraButton: {
        text: "Finalize pickup",
        param: "status",
        apiUrl: "reservations",
        value: "Picked up",
      },
      listView: {
        displayName: "Pickup Contract - Customer - RTA",
      },
      withID: true,
      buttonText: "Generate",
      hideButton: true,
      span: 6,
    },
    {
      name: "pickup_captain_contract",
      label: "Generated contract",
      type: "fileFetcher",
      filename: "Pickup Contract - Captain - RTA",
      url: "reservations/pickupcaptainrtacontract",
      hideComponent: [
        {
          if: "is_custom_pickup.defaultValue",
          equalsTo: false,
        },
        {
          if: "branch.code",
          equalsTo: "LB",
        },
      ],
      downloadurl: "reservations/downloadpickupcaptainrtacontract",
      listView: {
        displayName: "Pickup Contract - Captain - RTA",
      },
      withID: true,
      buttonText: "Generate",
      hideButton: true,
      span: 2,
    },
    {
      name: "finalize_button",
      fieldsToValidate: ["initial_odometer", "pickup_fuel_level"],
      type: "button",
      customValidate: isAdmin
        ? [{ field: "vehicle.defaultValue", notEqual: null }]
        : [],
      disabledIfField: enabledOnOpenOnly,
      span: 1,
      text: "Finalize pickup",
      param: "status",
      value: "Picked up",
      paramObj: {
        vehicle: {
          id: "vehicle.defaultValue",
          status: "Rented",
        },
      },
      apiUrl: "reservations",
      activeWhenFieldValues: ["signature.defaultValue"],
      ignore: {
        if: "is_custom_pickup.defaultValue",
        value: "captain_signature.defaultValue",
      },
      withID: true,
    },
    {
      name: "finalize_return_button",
      disabledIfField: enabledOnPickedUpOnly,
      fieldsToValidate: ["return_odometer", "return_fuel_level"],
      type: "button",
      span: 1,
      text: "Finalize return",
      param: "status",
      value: "Returned",
      paramObj: {
        vehicle: {
          id: "vehicle.defaultValue",
          status: "Available",
        },
      },
      apiUrl: "reservations",
      activeWhenFieldValues: ["return_signature.defaultValue"],
      ignore: {
        if: "is_custom_return.defaultValue",
        value: "return_captain_signature.defaultValue",
      },
      withID: true,
    },
    {
      name: "return_contract",
      label: "Generated contract",
      type: "fileFetcher",
      filename: "Return Contract - Customer",
      url: "reservations/returncontract",
      downloadurl: "reservations/downloadreturncontract",
      extraButton: {
        text: "Finalize pickup",
        param: "status",
        apiUrl: "reservations",
        value: "Picked up",
      },
      listView: {
        displayName: "Return Contract - Customer",
      },
      withID: true,
      buttonText: "Generate",
      hideButton: true,
      span: 2,
    },
    {
      name: "signcontract",
      type: "simpleHeading",
      label: "Sign contract",
      span: 1,
    },
    {
      name: "vehicleHeading",
      type: "simpleHeading",
      label: "Vehicle options",
      span: 1,
    },
    {
      name: "smoking_detected",
      type: "toggle",
      label: "Smoking detected",
      disabledIfField: enabledOnPickedUpOnly,
      singleLine: true,
      span: 1,
    },
    {
      name: "monthly_billing",
      type: "toggle",
      label: "Monthly billing",
      disabledIfField: enabledOnDraftAndOpenOnly,
      // singleLine: true,
      span: 3,
    },

    {
      name: "car_condition_heading",
      type: "simpleHeading",
      label: "Check car condition",
      span: 1,
    },
    {
      name: "needs_cleaning",
      type: "toggle",
      singleLine: true,
      disabledIfField: enabledOnPickedUpOnly,
      label: "Needs cleaning",
      span: 1,
    },
    {
      name: "return_captain_contract",
      label: "Generated contract",
      type: "fileFetcher",
      filename: "Return Contract - Captain - RTA",
      url: "reservations/returncaptainrtacontract",
      hideComponent: [
        {
          if: "is_custom_return.defaultValue",
          equalsTo: false,
        },
        {
          if: "branch.code",
          equalsTo: "LB",
        },
      ],
      downloadurl: "reservations/downloadreturncaptainrtacontract",
      listView: {
        displayName: "Return Contract - Captain - RTA",
      },
      withID: true,
      buttonText: "Generate",
      hideButton: true,
      span: 2,
    },
    {
      name: "return_captain_signature",
      type: "esignature",
      disabledIfField: enabledOnPickedUpOnly,
      label: "Captain's signature",
      hideComponent: [
        {
          if: "is_custom_return.defaultValue",
          equalsTo: false,
        },
        {
          if: "branch.code",
          equalsTo: "LB",
        },
      ],
      trigger: ["return_captain_contract"],
      span: 2,

      buttonText: "Generate captain's documents",
    },
    // {
    //   name: "early_return",
    //   label: "Early return",
    //   disabledIfField: enabledOnPickedUpOnly,
    //   type: "toggle",
    //   isRequired: false,
    //   disableAutoCalculateOnToggleOn: true,
    //   span: 3,
    //   disableCondition: [
    //     {
    //       value: true,
    //       params: ["none"],
    //       showparams: ["return_date"],
    //     },
    //     {
    //       value: false,
    //       params: ["return_date"],
    //       showparams: ["none"],
    //     },
    //   ],
    //   err: "Custom address is required",
    // },
    // Add more fields as needed
  ];
  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      allowedRoles: [admin, managerRole, financeRole, rentalPartnerRole, clientRole],
      fields: [
        "mainInfoHeading",
        "branch",
        "manager",
        "status",
        "currency",
        "contact",
        "monthly_billing",
        "bill_to_company",
        "COF_number",
        // "grace_period",
        "mainpickupHeading",
        "captain",
        "pickup_date",
        "is_custom_pickup",
        "pickup_fleet_location",
        "custom_pickup_street",
        "custom_pickup_state",
        "custom_pickup_city",
        "pickup_note",
        "mainreturnHeading",
        "return_captain",
        "return_date",
        // "early_return",
        "is_custom_return",
        "return_fleet_location",
        "custom_return_street",
        "custom_return_state",
        "custom_return_city",
        "return_note",
        "vehicleHeading",
        // "vehicle",
        // "vehicle_class",
        "vehicle_category_display",
        "reservationOptionsHeading",
        "mileage_option",
        "kilometers_limit",
        "coverage_option",
        "additional_drivers",
        "reservation_addons",
        "rates_change_history",
        "date_updated",
      ],
    },
    {
      name: "Billing",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole, rentalPartnerRole, clientRole],
      fields: [
        "pricingHeading",
        "auto_calculate",
        "rental_price",
        "rental_price_per_day",
        "contact_balance",
        "contact_deposit_balance",
        "security_deposit",
        "mileage_amount",
        "coverage_amount",
        "extra_price_km",
        "extra_kms_charge",
        "delivery_charges",
        "discount",
        "vat",
        "reservation_addons2",
        "transactions",
        // "finesAndChargesHeading",
        // "additional_charge",
        // "salik_charges",
        // "fines_charges",
        // "cleaning_charges",
        // "smoking_charges",
        // "damages_charges",
        // "fuel_charges",
        "time_extension",
        "charges",

      ],
      noGap: true,
      hasSummary: true,
      hasActions: true,
      summaryList: {
        mainTitle: "Order summary",
        total: {
          label: "Reservation balance",
          param: "balance",
        },
        depositTotal: {
          label: "Security deposit balance",
          param: "deposit_balance",
        },
        customerTotal: {
          label: "Customer balance",
          param: "customer_balance",
        },
        tax: {
          title: "TAX",
          subtitle: "<s>VAT (,vat,<s>%)",
          amount: "",
          number: "vat",
        },

        sublists: [
          {
            title: "Rent",
            items: [
              {
                title: "<days>pickup_date~return_date,<s>X days",
                daysCount: "<days>pickup_date~return_date,",
                amount: ",<d>rental_price",
                number: "rental_price",
                vat: true,
              },

              {
                title: "<s>Mileage",
                amount: ",<d>mileage_amount",
                number: "mileage_amount",
                vat: true,
              },
              {
                title: "<s>Cash surcharge",
                amount: ",<d>cash_surcharge",
                number: "cash_surcharge",
                vat: false,
              },
              {
                title: "<s>Coverage",
                amount: ",<d>coverage_amount",
                number: "coverage_amount",
                vat: true,
              },
              {
                title: "<s>Extra kilometers",
                amount: ",<d>extra_kms_charge",
                number: "extra_kms_charge",
                vat: true,
              },

              {
                title: "<s>Delivery charge",
                amount: ",<d>delivery_charges",
                number: "delivery_charges",
                vat: true,
              },
            ],
          },
          {
            title: "Fines & Charges",
            isArray: true,
            arrayParam: "charges",
            arrayitems: {
              title: "value.name",
              taxable: "value.taxable",
              deduct: "value.deduct",
              amount: "<fields>,<d>amount",
              number: "amount",
            },
            condition: {
              compareWith: "value.name",
              values: [],
            },
          },
          {
            title: "Time adjustment",
            isArray: true,
            arrayParam: "time_extension",
            arrayitems: {
              title: "<days>return_date~date_extended",
              dateExtended: "<day>date_extended",
              days: "days",
              taxable: "<s>true",
              amount: "<fields>,<d>total",
              number: "<fields>,<d>total",
              adjustmentType: "adjustment_type",
            },
            condition: {
              compareWith: "value.name",
              values: [],
            },
          },
          {
            title: "Extras",
            isArray: true,
            arrayParam: "reservation_addons",
            arrayitems: {
              title: "quantity,<s>X , , addon.name",
              amount: "<fields>,<d>price",
              number: "price",
              delete: "delete",
              vat: true,
            },
          },
          {
            title: "Reservation bill",
            items: [
              {
                title: "<s>Discount",
                amount: ",<d>discount",
                number: "<s>-,discount",
                vat: true,
              },
            ],
          },
          {
            title: "",
            items: [
              {
                title: "<s>Security deposit",
                amount: " ,<d>security_deposit",
                number: "security_deposit",
                ignore: true,
                isDeposit: true,
                vat: false,
              },
            ],
          },
          {
            title: "Payments",
            isArray: true,
            arrayParam: "transactions",
            arrayitems: {
              title: "type.name",
              amount: "<fields>,<d>amount",
              number: "amount",
              vat: false,
            },
            condition: {
              compareWith: "type.name",
              values: [
                {
                  name: "Security Deposit Payment",
                  operation: "subtract",
                },
                {
                  name: "Reservation Payment",
                  operation: "subtract",
                },
                {
                  name: "Reservation Refund",
                  operation: "add",
                },
                {
                  name: "Security Deposit Refund",
                  operation: "add",
                },
              ],
            },
          },
        ],
      },
    },
    {
      name: "Vehicle",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole],
      lockIfFieldValue: [
        {
          field: "status",
          value: "Draft",
          message:
            "You cannot proceed with the status set to 'draft'. Please update it to continue.",
        },
        {
          field: "status",
          value: "Picked up",
          message: "Vehicle changes are not permitted: vehicle is picked up.",
        },
        {
          field: "status",
          value: "Returned",
          message: "Vehicle changes are not permitted: vehicle is returned.",
        },
        {
          field: "status",
          value: "Closed",
          message: "Vehicle changes are not permitted: reservation is closed.",
        },
        {
          field: "status",
          value: "Canceled",
          message:
            "Vehicle changes are not permitted: reservation is canceled.",
        },
      ],
      fields: ["vehicle"],
    },
    // ,'setPayments','deposit_balance','balance','transactions'
    {
      name: "Pickup",
      href: "#",
      lockIfFieldValue: [
        {
          field: "vehicle.defaultValue",
          value: null,
          message: "Please select a vehicle first.",
        },
        {
          field: "status",
          value: "Draft",
          message:
            "You cannot proceed with the status set to 'draft'. Please update it to continue.",
        },
      ],
      current: false,
      hideNew: false,
      allowedRoles: [admin, managerRole, captain, operatorRole, financeRole, rentalPartnerRole, clientRole],
      fields: [
        "checkCaptainHeading",
        "captain",
        "pickup_note_2",
        "checkCarHeading",
        "initial_odometer",
        "pickup_fuel_level",
        "vehicleCard",
        "contactCard",
        "reservation_addons3",
        "vehicle_extra_items",
        "signcontract",
        // "pickup_contract_id",
        // "pickup_captain_contract_id",
        "signature",
        "pickup_contract",
        "customer_rta_contract",
        "captain_signature",
        "pickup_captain_contract",
        "finalize_button",
      ],
    },
    {
      name: "Return",
      href: "#",
      lockIfFieldValue: [
        {
          field: "vehicle.defaultValue",
          value: null,
          message: "Please select a vehicle first",
        },
        {
          field: "status",
          value: "Draft",
          message:
            "You cannot proceed with the status set to 'draft' or 'open'. Please update it to continue.",
        },
        {
          field: "status",
          value: "Open",
          message:
            "You cannot proceed with the status set to 'draft' or 'open'. Please update it to continue.",
        },
      ],
      current: false,
      hideNew: false,
      allowedRoles: [admin, managerRole, captain, operatorRole, financeRole, rentalPartnerRole, clientRole],
      fields: [
        "checkCaptainHeading",
        "return_captain",
        "return_note_2",
        "checkCarHeading",
        "return_odometer",
        "return_fuel_level",
        "vehicleCard2",
        "reservation_addons4",
        "vehicle_extra_items_return",
        "car_condition_heading",
        "needs_cleaning",
        "smoking_detected",
        // "returnCheckFines",
        // "salik_charges",
        // "fines_charges",
        // "cleaning_charges",
        // "smoking_charges",
        // "damages_charges",
        // "fuel_charges",
        // "setPayments2",
        // "deposit_balance",
        // "extra_kms_charge2",
        // "balance",
        // "transactions",
        "signcontract",
        "return_signature",
        "return_captain_signature",
        "return_contract",
        "return_captain_contract",
        "finalize_return_button",
      ],
    },
    //{ name: 'Documents', href: '#', current: false, fields: [] }
  ];
  // const temp = [...initFields];
  const getPromises = (temp) => {
    return [
      // fetchDataAndMapToField(config, 'fleetlocations', 'return_fleet_location', temp),
      // fetchDataAndMapToField(
      //   config,
      //   "users/reservationmanagers",
      //   "manager",
      //   temp,
      //   "first_name",
      //   "",
      //   ["first_name", "last_name"]
      // ),
      // fetchDataAndMapToField(
      //   config,
      //   "users/reservationcaptains",
      //   "captain",
      //   temp,
      //   "first_name",
      //   "location",
      //   ["first_name", "last_name"]
      // ),
      // fetchDataAndMapToField(
      //   config,
      //   "users/reservationcaptains",
      //   "return_captain",
      //   temp,
      //   "first_name",
      //   "location",
      //   ["first_name", "last_name"]
      // ),

      //fetchDataAndMapToField(config, 'fleetlocations', 'pickup_fleet_location', temp),
      fetchDataAndMapToField(
        config,
        "branches",
        "branch",
        temp,
        "Name",
        "currency",
        undefined,
        "code",
        "grace_period"
      ),
      fetchDataAndMapToField(
        config,
        "contacts",
        "contact",
        temp,
        undefined,
        undefined,
        undefined,
        "company",
        "balance",
        "email"
      ),
      fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code",
        "symbol"
      ),
      fetchDataAndMapToField(config, "vehicleclasses", "vehicle_class", temp),
      // fetchDataAndMapToField(
      //   config,
      //   "mileageoptions",
      //   "mileage_option",
      //   temp
      // ),
      // fetchDataAndMapToField(
      //   config,
      //   "coverageoptions",
      //   "coverage_option",
      //   temp
      // ),
      addAddiotionDrivertoExclude(
        config,
        temp,
        "reservation_addons",
        "additional_drivers"
      ),
    ];
  };
  useEffect(() => {
    var interval = setInterval(async function () {
      // Check if the variable is loaded
      const currentRole = await waitForCookie("_r");
      if (currentRole != null) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        // Delete the interval
        clearInterval(interval);
      }
    }, 100);

    return () => {
      setTabsData([]);
    };
  }, []);

  if (isReadOnlyRole) {
    const disableField = (field) => {
      if (!field) return;

      // 1. Force basic disable properties
      field.disabled = true;
      field.isFieldReadOnly = true; // For some custom components
      field.disableInput = true; // For some inputs like datepicker sometimes
      field.readOnly = true; 

      // 2. Remove conditional enable/disable logic that might override 'disabled: true'
      delete field.disabledIfField;
      delete field.disabledIfField2;
      delete field.alwaysEnabledIf;
      delete field.disableCondition;
      delete field.hideIfField; // Optional: keep hidden status or force visible? Assuming disable is enough.
      // delete field.hideComponent; 

      // 3. Handle specific types (Cards, etc.)
      // Prevent adding new items
      if (field.rowActionsShowNew !== undefined) field.rowActionsShowNew = false;
      if (field.headerAction !== undefined) field.headerAction = null;
      if (field.extraButton !== undefined) field.extraButton = null;

      // Disable or remove row actions (Edit/Delete)
      if (field.rowActions) {
        // Option A: Empty them
        // field.rowActions = []; 
        // Option B: Mark them hidden or disabled if supported, but typically removing is safer for read-only
        field.rowActions = []; 
      }
      
      // Specfic for signatures
       if (field.type === "esignature" || field.type === "button") {
        field.disabled = true;
        // Also remove triggers if necessary?
      }

      // 4. Recursive disabling for nested structures
      
      // Nested fields in generic 'fields' array (e.g. singleRelatedCard)
      if (Array.isArray(field.fields)) {
        field.fields.forEach(disableField);
      }

      // Nested inputField (used in some cards for the main input row)
      if (field.inputField) {
        disableField(field.inputField);
      }

      // Form Options (used for "Add New" modals) - good to disable just in case
      if (field.formOptions && Array.isArray(field.formOptions.fields)) {
         field.formOptions.fields.forEach(disableField);
      }
      
      // 'toShow' often defines display columns, but sometimes has editable configs? Usually just display.
      
      // 5. Handle Tabs/Sections if passed here (though usually we iterate initFields)
    };

    initFields.forEach(disableField);
  }

  return {
    apiRoute,
    initFields,
    onlyForm,
    getPromises,
    tabs,
    tabsData,
  };
};

export default useReservationLogic;
